import { nanoid } from 'nanoid';
import exposeApi from './api.js';
import { ShellMessageType, } from '../common/index.js';
export default class ShellClient {
    constructor() {
        this.deferredResponse = {};
        this.eventListeners = {};
    }
    setMessageBus(bus) {
        this.messageBus = bus;
        this.messageBus.onReceive((data) => {
            if (data.type === ShellMessageType.EVENT) {
                const event = data.message;
                const listeners = this.eventListeners[event.eventId] || [];
                listeners.forEach((listener) => listener(event.data));
            }
            else if (data.type === ShellMessageType.PLUGIN_RESULT) {
                this.handlePluginResult(data.message);
            }
        });
    }
    setApplicationId(id) {
        this.applicationId = id;
    }
    getApplicationId() {
        return this.applicationId;
    }
    getUniqueResponseId() {
        const uid = nanoid();
        return uid in this.deferredResponse ? this.getUniqueResponseId() : uid;
    }
    handlePluginResult(data) {
        const deferred = this.deferredResponse[data.uid];
        if (deferred) {
            if ('error' in data)
                deferred.reject(data.error);
            else if ('success' in data)
                deferred.resolve(data.success);
            else
                deferred.reject();
            delete this.deferredResponse[data.uid];
        }
    }
    addEventListener(eventId, callback) {
        if (!this.eventListeners[eventId]) {
            this.eventListeners[eventId] = [];
        }
        this.eventListeners[eventId].push(callback);
    }
    invokePluginMethod({ plugin, method, args = [], }) {
        const uid = this.getUniqueResponseId();
        if (!this.messageBus) {
            return Promise.reject(new Error('Message bus is not defined'));
        }
        this.messageBus.send({
            type: ShellMessageType.PLUGIN_INVOCATION,
            message: {
                uid,
                plugin,
                method,
                args,
            },
        });
        return new Promise((resolve, reject) => {
            this.deferredResponse[uid] = { resolve, reject };
        });
    }
    getApi() {
        return exposeApi(this);
    }
}
//# sourceMappingURL=shell-client.js.map